/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

export class InvalidModel extends Error {

    /**
     * @param {string} message 
     * @param {number} code 
     */
    constructor (message, code) {
        super(message);

        this.code = code;
    }
}
